/**
 * Returns the array without undefined entries
 */
export function filterUndefinedArrayEntries<A>(arr: (A | undefined)[]): A[] {
  return arr.filter((value) => value !== undefined) as A[];
}
